module.exports = __webpack_public_path__ + "media/images/front/icon_02_search_gr-af62e0ca01955b85367253a3d1d61dd7.png";